import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";

const NotFound = () => {
    return (
        <div data-testid="not-found-page" className="relative overflow-hidden bg-mist">
            <Seo
                title="Page introuvable | Eradikbreizh"
                description="Cette page n'existe pas ou a été déplacée. Eradikbreizh : traitement des punaises de lit et des cafards en Bretagne, intervention 7j/7."
                robots="noindex, follow"
            />
            <div className="absolute -right-40 top-0 h-[30rem] w-[30rem] rounded-full bg-brand/10 blur-[160px]" aria-hidden="true" />
            <div className="relative mx-auto flex min-h-[80vh] max-w-3xl flex-col items-center justify-center px-5 pb-24 pt-40 text-center sm:px-8">
                <p className="font-display text-sm font-bold uppercase tracking-[0.3em] text-brand">Erreur 404</p>
                <h1 className="mt-4 font-display text-4xl font-black uppercase leading-[1.05] tracking-tight text-night sm:text-5xl">
                    Page introuvable
                </h1>
                <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-600">
                    Cette page n'existe pas ou a été déplacée. Notre site a récemment changé d'adresses :
                    retrouvez ci-dessous nos pages principales, ou appelez-nous directement pour toute
                    urgence punaises de lit ou cafards.
                </p>
                <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row">
                    <a
                        data-testid="not-found-call-button"
                        href="tel:+33255992243"
                        className="inline-flex items-center gap-2 rounded-full bg-brand px-8 py-4 font-bold text-white transition-[background-color,transform] duration-300 hover:bg-brand-hover hover:scale-[1.02] active:scale-95"
                    >
                        <Phone className="h-5 w-5" />
                        02 55 99 22 43
                    </a>
                    <Link
                        data-testid="not-found-tarifs-link"
                        to="/tarifs"
                        className="inline-flex items-center gap-2 rounded-full border-2 border-night/15 bg-white px-8 py-4 font-bold text-night transition-[border-color,transform] duration-300 hover:border-brand hover:text-brand hover:scale-[1.02] active:scale-95"
                    >
                        Voir les tarifs
                        <ArrowRight className="h-5 w-5" />
                    </Link>
                </div>
                <nav className="mt-12 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm font-semibold">
                    <Link data-testid="not-found-link-accueil" to="/" className="text-slate-500 transition-colors hover:text-brand">Accueil</Link>
                    <Link data-testid="not-found-link-punaises" to="/punaises-de-lit" className="text-slate-500 transition-colors hover:text-brand">Punaises de lit</Link>
                    <Link data-testid="not-found-link-cafards" to="/cafards" className="text-slate-500 transition-colors hover:text-brand">Cafards</Link>
                    <Link data-testid="not-found-link-secteurs" to="/zone-intervention" className="text-slate-500 transition-colors hover:text-brand">Secteurs</Link>
                    <Link data-testid="not-found-link-contact" to="/contact" className="text-slate-500 transition-colors hover:text-brand">Contact</Link>
                </nav>
            </div>
        </div>
    );
};

export default NotFound;
